/**
 * SAP CONFIDENTIAL
 *
 * This software is confidential proprietary software licensed by SAP SE
 * and is not to be used, duplicated or disclosed to anyone without the
 * prior written permission of SAP.
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Component, OnInit, ViewEncapsulation, ViewChild, Input,Output, EventEmitter  } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { NgForm } from '@angular/forms';
import { CommonService } from '../services/common.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

export class FlagRule {
  id!: number;
  flagDefinition: any = { code: '', id: '' };
  flagValue: any = { id: [] };
  description: any;
  singleflagValue: any;
}

@Component({
  templateUrl: './common-flags-modal.component.html',
  styleUrls: ['./common-flags-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class CommonFlagsModalComponent implements OnInit {
  @ViewChild('flagsForm') flagsForm!: NgForm;
  @Input() data: any;
  @Input() pattern?: any;
  @Input() singleSelction?: boolean;
  @Output() onSave = new EventEmitter<any>();
  @Output() onClose = new EventEmitter<void>();
  private param: any;
  public title!: string;
  public flagRules: any = [];
  public noflagRules = false;
  public flagOperationIndex = 0;
  public duplicateFlag:any = false;
  public mlsSettings: IDropdownSettings = {
    allowSearchFilter: false,
    itemsShowLimit: 1,
    enableCheckAll: true,
    selectAllText: 'Select All',
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    unSelectAllText: 'UnSelect All',
  };

  constructor(public bsModalRef: BsModalRef,
    public commonService: CommonService) { }

  ngOnInit() {
    this.flagRules = this.data?.flagRules || [];
    this.flagRules.forEach((flagRule: any, index: number) => {
      this.flagOperationIndex++;
    });
  }

  public getTranslationWithKey(key: string) {
    return this.commonService.getTranslatedVal(key);
  }

  public getFlagValues(rule: any, selectedFlagId: any) {
    let flagValues: any = [];
    // Array.length= 0  creates a new array by destroying all references to the existing array
    // Used here to clear past selections
    if (Array.isArray(rule.flagValue.id)) {
      rule.flagValue.id.length = [];
    }
    this.data.flagsMetadata.forEach((element: any) => {
      if (parseInt(element.id) === parseInt(selectedFlagId)) {
        flagValues = element.flagValues;
      }
    });
    flagValues.forEach((value: any) => {
      value.name = value.value;
    });
    rule.flagValues = JSON.parse(JSON.stringify(flagValues));
  }

  public closeModalWindow() {
    this.onClose.emit();
    this.bsModalRef.hide();
  }

  public applyChange() {
    this.duplicateFlag = false;
    this.flagRules.filter((flag: any)=> flag.operation!='Delete').forEach((flagRule: any) => {
      flagRule.existingFlags = this.commonService.getFlagValuesFromId(flagRule);
      const selectedFlagDef = this.getFlagCodeFromId(+flagRule.flagDefinition.id);
      flagRule.flagDefinition = {
        id: selectedFlagDef.id,
        code: selectedFlagDef.code,
        name: selectedFlagDef.name
      };
    });
    if(this.hasValidFlagRules()){
      this.onSave.emit(this.flagRules);
      this.bsModalRef.hide();
    }else{
      this.duplicateFlag = true;
    }
  }

  private hasValidFlagRules(){
    let flags: any =[], flagValid=true;
    this.flagRules.filter((flag: any)=> flag.operation!='Delete').forEach(function(flag: any){
      if(flags.indexOf(flag.flagDefinition.id)<=-1){
        flags.push(flag.flagDefinition.id);
      }else{
        flagValid =false
      }
    })
    return flagValid;
  }

  private getFlagCodeFromId(inputId: number) {
    return this.data.flagsMetadata.find((flag: any) => {
      return flag.id == inputId;
    });
  }

  public addNewFlag() {
    this.noflagRules = false;
    const flagRule: any = new FlagRule();
    flagRule.operation = 'Create';
    this.flagOperationIndex = this.flagRules.length == 0 ? 0 :
      Math.max(...this.flagRules.map((rule: any) => rule.flagOperationIndex));
    this.flagOperationIndex++;
    flagRule.flagOperationIndex = this.flagOperationIndex;
    flagRule.flagDefinition.id = '';
    this.flagRules.push(flagRule);
  }

  public removeFlag(rule: any, index: number) {
    if (rule.id) {
      rule['operation'] = 'Delete';
      this.flagsForm?.form?.markAsDirty();
    }else {
      this.flagRules.splice(index, 1);
	  this.flagsForm?.form?.markAsDirty();
    }

    // logic to show No Volume Rules
    const deletedRules = this.flagRules.filter(function(rule: any) {
      return (rule.operation === 'Delete');
    });
    this.noflagRules = (deletedRules.length === this.flagRules.length);
  }
}
